var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      staticClass: "v-icon__svg",
      attrs: { width: "24px", height: "24px", viewBox: "0 0 24 24" },
    },
    [
      _c("path", {
        attrs: {
          d: "M14,3 C14.5522847,3 15,3.44771525 15,4 L15,5.25 L18,3 L18,9 L15,6.75 L15,8 C15,8.55228475 14.5522847,9 14,9 L8,9 C7.44771525,9 7,8.55228475 7,8 L7,4 C7,3.44771525 7.44771525,3 8,3 L14,3 Z",
        },
      }),
      _c("g", { attrs: { transform: "translate(6.000000, 11.000000)" } }, [
        _c("path", {
          attrs: {
            d: "M6.5,-3.55271368e-15 C10.0898509,-3.55271368e-15 13,2.23857625 13,5 C13,7.07975802 11.3492749,8.86294104 9.00068948,9.61657621 L9.00154528,7.47973348 C10.2270612,6.9165937 11,5.96848751 11,5 C11,3.47472383 9.08285902,2 6.5,2 C3.91714098,2 2,3.47472383 2,5 C2,6.21118259 3.20886088,7.39048921 4.99998678,7.82482763 L4.99986773,9.86618224 C2.13323438,9.34525011 0,7.3642572 0,5 C0,2.23857625 2.91014913,-3.55271368e-15 6.5,-3.55271368e-15 Z",
          },
        }),
        _c("polygon", {
          attrs: {
            transform:
              "translate(6.500000, 9.000000) scale(-1, 1) rotate(-90.000000) translate(-6.500000, -9.000000) ",
            points: "6.5 7.5 9.5 10.5 3.5 10.5",
          },
        }),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }